export default __webpack_public_path__ + "static/media/e.b4ad6dd84e71111b42a114159f7136ac.mp3";